import React, { Component, Fragment } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import LayoutForm from './LayoutForm';

export default class ListLayouts extends Component {
  state = {
    isEdit: false,
  };

  showEditForm = layoutId => {
    this.setState({ isEdit: true, layoutId });
  };

  hideEditForm = () => {
    this.setState({ isEdit: false, layoutId: '' });
  };

  showSnippetName = uuid => {
    const { snippets } = this.props;
    const snippet = snippets.find(e => e.uuid === uuid);
    return snippet ? snippet.name : '';
  };

  handleDelete = uuid => {
    this.props.handleDelete(uuid);
  };

  handleSubmit = async values => {
    const { layoutId } = this.state;
    await this.props.handleLayoutUpdate(values, layoutId);
    this.hideEditForm();
  };

  showLayoutsDetail = layout => {
    return (
      <AccordionItem key={layout.uuid}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <i className={`wb`}></i> <strong>{layout.name}</strong>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          {this.state.isEdit && this.state.layoutId === layout.uuid ? (
            <LayoutForm
              handleSubmit={this.handleSubmit}
              snippets={this.props.snippets}
              closeNewLayout={this.hideEditForm}
              layout={layout}
            />
          ) : (
            <Fragment>
              <div className="table-responsive">
                <table className="table border-none">
                  <tbody>
                    <tr>
                      <th>Name:</th>
                      <td>{layout.name}</td>
                    </tr>
                    <tr>
                      <th>Header: </th>
                      <td>{this.showSnippetName(layout.header)}</td>
                    </tr>
                    <tr>
                      <th>Sidebar: </th>
                      <td>{this.showSnippetName(layout.sidebar)}</td>
                    </tr>
                    <tr>
                      <th>Footer: </th>
                      <td>{this.showSnippetName(layout.footer)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-12 text-right">
                <button
                  type="button"
                  className="btn btn-theme-submit"
                  onClick={() => this.showEditForm(layout.uuid)}
                >
                  <i className="wb webconnect-pencil"></i> Edit
                </button>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-theme-delete"
                  onClick={() => this.handleDelete(layout.uuid)}
                >
                  <i className="wb webconnect-trash-solid"></i> Delete
                </button>
              </div>
            </Fragment>
          )}
        </AccordionItemPanel>
      </AccordionItem>
    );
  };

  render() {
    const { layouts } = this.props;
    return (
      <div className="row">
        <div className="col-12">
          <Accordion allowZeroExpanded>
            {layouts.map(layout => this.showLayoutsDetail(layout))}
          </Accordion>
        </div>
      </div>
    );
  }
}
